import React from 'react'
import { Modal } from 'react-bootstrap'
import { images } from '../../constants/images';

const PromoCodeItemPopup = ({ show, OnClick, children, handingName }: {
    show?: boolean,
    OnClick: () => {},
    children?: React.ReactNode
    handingName?: string
}) => {
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {handingName}
                </Modal.Title>
                <div className="close">
                    <img width="24px" src={images.Close} onClick={OnClick} alt="" />    
                </div>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    )
}

export default PromoCodeItemPopup;
